import React from 'react';
import Waiting from '../SVGs/waiting';

const Loading = () => {
  return (
    <div
      style={{
        backgroundColor: '#e6e6e6',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        width: '100%',
        height: '100%'
      }}
    >
      <div style={{ width: '50%', maxWidth: '600px' }}>{Waiting}</div>
      <h2> Loading </h2>
    </div>
  );
};
export default Loading;
